import type { z } from 'zod';

import type { RoomSchema } from './schemas';

type RoomField = keyof z.infer<typeof RoomSchema>;

const listAttributes = ['id', 'location', 'code', 'label'] as const satisfies readonly RoomField[];
const getAttributes = [...listAttributes] as const satisfies readonly RoomField[];

export const RoomAttributes = {
  List: listAttributes,
  Get: getAttributes,
};
